<template>
    <mytask-form />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import MyTaskForm from '@/components/mytask/Form.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'mytask-form': MyTaskForm
    }
})
</script>
